module.exports = __webpack_public_path__ + "static/media/falling_star_grey.da53aede.svg";